module.exports = __webpack_public_path__ + "static/media/p_41_3.ed6e9798.png";